import { render, staticRenderFns } from "./SaveConsultantBasicInformationSidebar.vue?vue&type=template&id=b508d516&scoped=true"
import script from "./SaveConsultantBasicInformationSidebar.vue?vue&type=script&lang=js"
export * from "./SaveConsultantBasicInformationSidebar.vue?vue&type=script&lang=js"
import style0 from "./SaveConsultantBasicInformationSidebar.vue?vue&type=style&index=0&id=b508d516&prod&lang=scss&scoped=true"
import style1 from "./SaveConsultantBasicInformationSidebar.vue?vue&type=style&index=1&id=b508d516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b508d516",
  null
  
)

export default component.exports